<div class="my-dropdown" [class.open]="isOpen" [class.disabled]="disabled">
  <button class="my-dropdown__toggle" (click)="toggleDropdown()">
    <div class="text">
      {{ selectedItem?.keyName && !disabled ? selectedItem.keyName : (placeholder || 'Select') }}
    </div>
    <i class="fa-solid fa-angle-down" *ngIf="!disabled"></i>
  </button>

  <ul class="my-dropdown__menu" #menu (scroll)="checkScroll()">
    <li *ngFor="let item of items" [class.active]="openSubmenus[item.keyName]">
      <button class="my-dropdown__menu--toggle" (click)="selectItem(item, $event)" [disabled]="disabled">
        <div class="text">
          {{ item.keyName | titlecase }}
        </div>
        <i *ngIf="item.sub?.length && !disabled" class="fa-solid fa-arrow-right"></i>
      </button>
      <ul class="my-dropdown__menu--sub" [class.open]="openSubmenus[item.keyName]">
        <li *ngFor="let i of item.sub" [class.active]="isActive(i)" (click)="selectItem(i, $event)">
          {{ i.keyName }}
        </li>
      </ul>
    </li>
    <li class="my-dropdown__menu--arrow" (click)="scroll()" [class.up]="!buttonLabel"><i class="fa-solid fa-angle-down"></i></li>
  </ul>
</div>
